export var PlaneSide;
(function (PlaneSide) {
    PlaneSide["UPPER"] = "upper";
    PlaneSide["LOWER"] = "lower";
})(PlaneSide || (PlaneSide = {}));
export var ShapeKeyType;
(function (ShapeKeyType) {
    ShapeKeyType["CYLINDER"] = "cylinders";
    ShapeKeyType["POLYGON"] = "polygons";
})(ShapeKeyType || (ShapeKeyType = {}));
/** Terminal states of a `detect-shapes` job as reported by the job-status endpoint. */
export var DetectShapesJobStatus;
(function (DetectShapesJobStatus) {
    DetectShapesJobStatus["SUCCEEDED"] = "SUCCEEDED";
    DetectShapesJobStatus["FAILED"] = "FAILED";
})(DetectShapesJobStatus || (DetectShapesJobStatus = {}));
